import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../store/store";
import { Insight } from "@stratify/shared";

const selectInsightsState = (state: RootState) => state.insights;

export const selectInsightsByDocument = (documentId: string) =>
  createSelector(
    [selectInsightsState],
    (insightsState): Insight[] =>
      insightsState.insightsByDocument[documentId] || []
  );

export const selectInsightsLoading = createSelector(
  [selectInsightsState],
  (insightsState) => insightsState.loading
);

export const selectInsightsError = createSelector(
  [selectInsightsState],
  (insightsState) => insightsState.error
);
export const selectInsightById = (insightId: string) =>
  createSelector(
    [selectInsightsState],
    (insightsState): Insight | undefined => {
      // Search through all documents for the insight with matching id
      for (const insights of Object.values(insightsState.insightsByDocument)) {
        const found = insights.find((insight) => insight.id === insightId);
        if (found) return found;
      }
      return undefined;
    }
  );
